var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { colors, cssVarsThemed, semanticColors, typographyCss } from '@creditornot/cb-ingredients';
import { createCssVars, themedConfigToThemedAttrs } from '@creditornot/cb-utils';
import CrossIcon from './CrossIcon';
import TagRemoveButton from './TagRemoveButton';
var removeButtonVariantConfigs = {
    blue: {
        bg: colors.wolt8,
        bgHover: colors.wolt8,
        bgActive: colors.wolt16,
        iconFill: colors.wolt100,
        iconFillHover: colors.wolt100,
        iconFillDisabled: colors.wolt40,
    },
    darkBlue: {
        bg: colors.nightSky8,
        bgHover: colors.nightSky8,
        bgActive: colors.nightSky16,
        iconFill: colors.nightSky100,
        iconFillHover: colors.nightSky100,
        iconFillDisabled: colors.nightSky40,
    },
    black: {
        bg: colors.pepper8,
        bgHover: colors.pepper8,
        bgActive: colors.pepper16,
        iconFill: colors.pepper100,
        iconFillHover: colors.pepper100,
        iconFillDisabled: colors.pepper40,
    },
    green: {
        bg: colors.lime8,
        bgHover: colors.lime8,
        bgActive: colors.lime16,
        iconFill: colors.lime100,
        iconFillHover: colors.lime100,
        iconFillDisabled: colors.lime40,
    },
    yellow: {
        bg: colors.banana8,
        bgHover: colors.banana8,
        bgActive: colors.banana16,
        iconFill: colors.banana100,
        iconFillHover: colors.banana100,
        iconFillDisabled: colors.banana40,
    },
    orange: {
        bg: colors.orange8,
        bgHover: colors.orange8,
        bgActive: colors.orange16,
        iconFill: colors.orange100,
        iconFillHover: colors.orange100,
        iconFillDisabled: colors.orange40,
    },
    red: {
        bg: colors.strawberry8,
        bgHover: colors.strawberry8,
        bgActive: colors.strawberry16,
        iconFill: colors.strawberry100,
        iconFillHover: colors.strawberry100,
        iconFillDisabled: colors.strawberry40,
    },
    white: {
        bg: colors.salt8,
        bgHover: colors.salt8,
        bgActive: colors.salt16,
        iconFill: colors.salt100,
        iconFillHover: colors.salt100,
        iconFillDisabled: colors.salt40,
    },
};
var variantConfigs = {
    blue: {
        light: {
            borderColor: 'transparent',
            bg: colors.wolt100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.wolt100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    darkBlue: {
        light: {
            borderColor: 'transparent',
            bg: colors.nightSky100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.nightSky100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    black: {
        light: {
            borderColor: 'transparent',
            bg: colors.pepper100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.salt100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    green: {
        light: {
            borderColor: 'transparent',
            bg: colors.lime100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.lime100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    yellow: {
        light: {
            borderColor: 'transparent',
            bg: colors.banana100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.banana100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
    },
    orange: {
        light: {
            borderColor: 'transparent',
            bg: colors.orange100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.orange100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
    },
    red: {
        light: {
            borderColor: 'transparent',
            bg: colors.strawberry100,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.strawberry100,
            color: colors.space100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
    },
    lightBlue: {
        light: {
            borderColor: 'transparent',
            bg: colors.wolt8,
            color: colors.wolt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.blue), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.wolt12,
            color: colors.wolt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.blue), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightDarkBlue: {
        light: {
            borderColor: 'transparent',
            bg: colors.nightSky8,
            color: colors.nightSky100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.darkBlue), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.nightSky64,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightBlack: {
        light: {
            borderColor: 'transparent',
            bg: colors.pepper8,
            color: colors.pepper100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.salt16,
            color: colors.salt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightGreen: {
        light: {
            borderColor: 'transparent',
            bg: colors.lime8,
            color: colors.lime100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.green), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.lime12,
            color: colors.lime100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.green), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightYellow: {
        light: {
            borderColor: 'transparent',
            bg: colors.banana8,
            color: colors.banana100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.yellow), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.banana12,
            color: colors.banana100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.yellow), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightOrange: {
        light: {
            borderColor: 'transparent',
            bg: colors.orange8,
            color: colors.orange100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.orange), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.orange12,
            color: colors.orange100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.orange), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    lightRed: {
        light: {
            borderColor: 'transparent',
            bg: colors.strawberry8,
            color: colors.strawberry100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.red), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: colors.strawberry12,
            color: colors.strawberry100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.red), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    white: {
        light: {
            borderColor: 'transparent',
            bg: semanticColors.light.surfaceMain,
            color: semanticColors.light.textPrimary,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: 'transparent',
            bg: semanticColors.dark.surfaceMain,
            color: semanticColors.dark.textPrimary,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineBlue: {
        light: {
            borderColor: colors.wolt100,
            bg: 'transparent',
            color: colors.wolt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.blue), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.wolt100,
            bg: 'transparent',
            color: colors.wolt100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.blue), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineBlack: {
        light: {
            borderColor: colors.pepper100,
            bg: 'transparent',
            color: semanticColors.light.textPrimary,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.black), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.salt100,
            bg: 'transparent',
            color: semanticColors.dark.textPrimary,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.white), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineGreen: {
        light: {
            borderColor: colors.lime100,
            bg: 'transparent',
            color: colors.lime100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.green), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.lime100,
            bg: 'transparent',
            color: colors.lime100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.green), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineYellow: {
        light: {
            borderColor: colors.banana100,
            bg: 'transparent',
            color: colors.banana100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.yellow), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.banana100,
            bg: 'transparent',
            color: colors.banana100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.yellow), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineOrange: {
        light: {
            borderColor: colors.orange100,
            bg: 'transparent',
            color: colors.orange100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.orange), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.orange100,
            bg: 'transparent',
            color: colors.orange100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.orange), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
    outlineRed: {
        light: {
            borderColor: colors.strawberry100,
            bg: 'transparent',
            color: colors.strawberry100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.red), { focusOutline: semanticColors.light.a11yFocusIndicator }),
        },
        dark: {
            borderColor: colors.strawberry100,
            bg: 'transparent',
            color: colors.strawberry100,
            removeButtonConfig: __assign(__assign({}, removeButtonVariantConfigs.red), { focusOutline: semanticColors.dark.a11yFocusIndicator }),
        },
    },
};
var variantCssVars = createCssVars([
    'borderColor',
    'bg',
    'color',
]);
var sizeConfigs = {
    tiny: {
        height: 20,
        iconSize: 12,
        removeButtonSize: 8,
        typography: {
            lowercase: typographyCss.Tiny,
            uppercase: typographyCss.Overline4,
        },
    },
    small: {
        height: 24,
        iconSize: 12,
        removeButtonSize: 10,
        typography: {
            lowercase: typographyCss.Small,
            uppercase: typographyCss.Overline3,
        },
    },
};
var IconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-inline-end: ", "px;\n  padding-inline-start: ", "px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding-inline-end: ", "px;\n  padding-inline-start: ", "px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var $position = _a.$position;
    return ($position === 'left' ? 4 : 0);
}, function (_a) {
    var $position = _a.$position;
    return ($position === 'right' ? 4 : 0);
});
var Root = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  flex-shrink: 0;\n\n  height: ", "px;\n  padding: 2px 8px;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n\n  ", " svg {\n    width: ", "px;\n    fill: ", ";\n  }\n"], ["\n  ", "\n\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  flex-shrink: 0;\n\n  height: ", "px;\n  padding: 2px 8px;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n\n  ", " svg {\n    width: ", "px;\n    fill: ", ";\n  }\n"])), function (_a) {
    var $variant = _a.$variant;
    return cssVarsThemed({
        bg: {
            light: variantConfigs[$variant].light.bg,
            dark: variantConfigs[$variant].dark.bg,
        },
        borderColor: {
            light: variantConfigs[$variant].light.borderColor,
            dark: variantConfigs[$variant].dark.borderColor,
        },
        color: {
            light: variantConfigs[$variant].light.color,
            dark: variantConfigs[$variant].dark.color,
        },
    });
}, function (_a) {
    var $size = _a.$size;
    return sizeConfigs[$size].height;
}, variantCssVars.bg, variantCssVars.color, variantCssVars.borderColor, IconContainer, function (_a) {
    var $size = _a.$size;
    return sizeConfigs[$size].iconSize;
}, variantCssVars.color);
var Label = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  ", "\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n"], ["\n  flex: 1;\n  box-sizing: border-box;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  ", "\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n"])), function (_a) {
    var $size = _a.$size, $uppercase = _a.$uppercase;
    return $uppercase ? sizeConfigs[$size].typography.uppercase : sizeConfigs[$size].typography.lowercase;
});
var RemoveButtonContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-inline-start: 8px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding-inline-start: 8px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Tag = function (_a) {
    var children = _a.children, icon = _a.icon, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b, onRemoveClick = _a.onRemoveClick, removeButtonAriaLabel = _a.removeButtonAriaLabel, _c = _a.removeButtonProps, removeButtonProps = _c === void 0 ? {} : _c, removeDisabled = _a.removeDisabled, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.uppercase, uppercase = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'blue' : _f, rest = __rest(_a, ["children", "icon", "iconPosition", "onRemoveClick", "removeButtonAriaLabel", "removeButtonProps", "removeDisabled", "size", "uppercase", "variant"]);
    return (React.createElement(Root, __assign({ "$size": size, "$variant": variant }, rest),
        !!icon && iconPosition === 'left' && (React.createElement(IconContainer, { "$position": iconPosition }, icon)),
        React.createElement(Label, { "$size": size, "$uppercase": uppercase }, children),
        !!icon && iconPosition === 'right' && (React.createElement(IconContainer, { "$position": iconPosition }, icon)),
        !!(onRemoveClick || removeButtonProps.onClick) && (React.createElement(RemoveButtonContainer, null,
            React.createElement(TagRemoveButton, __assign({}, removeButtonProps, { "aria-label": removeButtonAriaLabel ||
                    removeButtonProps['aria-label'] ||
                    (typeof children === 'string' ? "Remove ".concat(children) : 'Remove'), colorConfig: themedConfigToThemedAttrs({
                    light: variantConfigs[variant].light.removeButtonConfig,
                    dark: variantConfigs[variant].dark.removeButtonConfig,
                }), disabled: removeDisabled !== null && removeDisabled !== void 0 ? removeDisabled : removeButtonProps.disabled, iconSize: sizeConfigs[size].removeButtonSize, onClick: onRemoveClick || removeButtonProps.onClick }),
                React.createElement(CrossIcon, null))))));
};
export default Tag;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Tag.js.map